import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../foundation/cn';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  readonly label?: string;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, className, id, ...rest },
  ref,
) {
  const input = (
    <input
      ref={ref}
      id={id}
      type="checkbox"
      className={cn(
        'h-4 w-4 rounded-sm border-border text-primary',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
        'disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
  if (label === undefined) {
    return input;
  }
  return (
    <label htmlFor={id} className="inline-flex items-center gap-2 text-sm text-fg">
      {input}
      {label}
    </label>
  );
});
